module.exports = __webpack_public_path__ + "static/media/large_painting.91280142.jpg";